import {Component, OnInit} from "@angular/core";
import {DartDealService} from "../deal-list/dart-deals.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {handleErrors} from "../misc/handle-errors.decorator";
import {FilteredList} from "../helpers/filtered-list";
import {DealModel} from "../deal-list/deal-list.gql-model";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./dart-deal-list.template.pug",
  providers: [
    DartDealService,
  ],
})
export class DartDealListComponent implements OnInit {
  dartDeals: FilteredList<DealModel> = new FilteredList<DealModel>({
    searchKeys: ["dealKey"],
    exactMatchSearchKeys: ["id"],
    startingPage: DEFAULT_PAGE,
    startingPageSize: DEFAULT_PAGE_LIMIT,
  });

  error: Error;

  ngOnInit(): void {
    this.loadData();

    this.route.queryParams.forEach((value: Params) => {
      this.dartDeals.setParams(value.page, value.limit, value.search);
    });
  }

  @handleErrors()
  async loadData() {
    const {deals} = await this.dartDealService.getFullList();
    this.dartDeals.items = deals;
  }

  @handleErrors()
  async onListControlsChange(event) {
    this.dartDeals.onListControlsChange(event);

    const queryParams = {
      page: this.dartDeals.currentPage,
      limit: this.dartDeals.pageSize,
      search: this.dartDeals.searchText,
    };

    await this.router.navigate(["dart-deals"], {queryParams});
  }

  @handleErrors()
  async remove(dealId) {
    await this.dartDealService.remove(dealId);
    await this.loadData();
  }

  @handleErrors()
  async importDartDealDialogClosed(event: any) {
    const result = event["value"] as boolean;

    if (result) {
      await this.loadData();
    }
  }

  constructor(
    private dartDealService: DartDealService,
    public route: ActivatedRoute,
    public router: Router,
  ) {}
}
